export interface BrandPalette {
  'brand-background': string;
  'brand-text': string;
  'brand-border': string;
  'brand-box-shadow': string;
  'brand-hover-background': string;
  'brand-hover-light-background': string;
  'brand-hover-text': string;
  'brand-hover-border': string;
  'brand-focus-background': string;
  'brand-focus-text': string;
  'brand-focus-border': string;
  'brand-focus-box-shadow': string;
  'brand-active-background': string;
  'brand-active-text': string;
  'brand-active-border': string;
  'brand-outlined-background': string;
  'brand-outlined-text': string;
  'brand-outlined-border': string;
  'brand-outlined-hover-background': string;
  'brand-outlined-hover-text': string;
  'brand-outlined-hover-border': string;
  'brand-outlined-focus-background': string;
  'brand-outlined-focus-text': string;
  'brand-outlined-focus-border': string;
  'brand-outlined-active-background': string;
  'brand-outlined-active-text': string;
  'brand-outlined-active-border': string;
}
